import React from 'react'
import { RouteComponentProps } from '@reach/router'

const Intestatari: React.FC<RouteComponentProps> = ({ children }) => {
  return <div>{children}</div>
}

export default Intestatari
